// @mui
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { translateKey } from 'src/locales/translate';


// ----------------------------------------------------------------------

interface ProfileMedicationsDeleteModalProps {
  isOpen: boolean;
  handleClose: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}

export default function ProfileMedicationsDeleteModal({
  isOpen,
  handleClose,
  onDelete,
  isLoading,
}: ProfileMedicationsDeleteModalProps) {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{translateKey("hardcoded.usun_lekarstwo")}</DialogTitle>

      <DialogContent sx={{ maxWidth: '400px' }}>
        <DialogContentText id="alert-dialog-description">{translateKey("hardcoded.czy_na_pewno_chcesz_usunac_ten_lekarstwo")}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleClose}>{translateKey("common.close")}</Button>
        <LoadingButton
          variant="contained"
          color="error"
          data-testid="medication-delete-confirm"
          onClick={onDelete}
          disabled={isLoading}
          loading={isLoading}
        >
          <span>{translateKey("common.remove")}</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
